import React, { Suspense, useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import './App.css';
import Sidebar from './component/common/Sidebar';
import { CommonContextProvider } from './context/CommonContext';
import Pageloader from './component/common/Pageloader';
import CustomTheme from './component/common/CustomTheme';
import Merchant from './component/merchant';
import PickupView from './component/pickup';
import PickupPointsView from './component/pickupPoints';
import ShipmentsView from './component/shipments';
import RTOView from './component/rto';
import BranchView from './component/branches';
import UsersView from './component/users';
import DownloadView from './component/download';
import TrackingView from './component/trackingQuote';
import WeightScreenView from './component/weight';
import FreightView from './component/freight';
import InvoiceView from './component/invoice';
import ServiceabilityView from './component/serviceability';
import 'rsuite/dist/rsuite.css';
import ScanView from './component/scanStatus';
import NotFound from './context/NotFound ';
import MerchantSignIn from './component/common/MerchantSignIn';
import MerchantSignUp from './component/common/MerchantSignUp';
import CryptoJS from 'crypto-js';
import SiteSetting from './component/siteSetting';
import PricingView from './component/pricing';
import Remittance from './component/remittance';
// import Ndr from './component/ndr';
import Couriers from './component/couriers';
// import Dashboard from './component/dashboard';
import Channel from './component/channel';
import Utility from './component/utility';
import Footer from './component/common/Footer';
import Ivr from './component/ivr';
import ShipmentsViewb2b from './component/shipmentsb2b/ShipmentsViewb2b';
import Recharge from './component/recharge';
import Asset from './component/asset';
import SignupMerchant from './component/signupMerchant';


const AdminSignIn = React.lazy(() => import('./component/common/AdminSignIn'));
const DashboardTab = React.lazy(() => import('./component/common/DashboardTab'));
const NdrTab = React.lazy(() => import('./component/common/NdrTab'));
const WeightTab = React.lazy(() => import('./component/common/WeightTab'));
const InvoiceTab = React.lazy(() => import('./component/common/InvoiceTab'));
const CreditNoteTab = React.lazy(() => import('./component/common/CreditNoteTab'));
const FreightTab = React.lazy(() => import('./component/common/FreightTab'));
const PaymentStatus = React.lazy(() => import('./component/common/PaymentStatus'));
const CreateOrder = React.lazy(() => import('./component/shipments/CreateOrder'));
const OrderDetails = React.lazy(() => import('./component/shipments/OrderDetails'));
const CreateOrderb2b = React.lazy(() => import('./component/shipmentsb2b/CreateOrderb2b'));
const OrderDetailsb2b = React.lazy(() => import('./component/shipmentsb2b/OrderDetailsb2b'));
const CalculatorTab = React.lazy(() => import('./component/freight/CalculatorTab'));

// Decrypt function
const decryptData = (encryptedData, secretKey) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

const secretKey = 'app-secret';
function App() {
  let location = useLocation();
  const storedUserData = localStorage.getItem('userApp');
  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [userPermission, setUserPermission] = useState(null);
  useEffect(() => {
    if (storedUserData) {
      const parsedUser = decryptData(storedUserData, secretKey);
      // setUser(user);
      if (parsedUser?.permissions) {
        setUserPermission(JSON.parse(parsedUser?.permissions))
      }
      setUser(parsedUser);
      if (parsedUser?.permissions) {
        setUserPermission(JSON.parse(parsedUser?.permissions))
      }
      setUser(parsedUser);
    }
  }, [storedUserData]);
// console.log(userPermission,'userPermissionuserPermission')
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  return (
    <CommonContextProvider>
      <ThemeProvider theme={CustomTheme}>
        <div className="App">
          {location.pathname !== '/admin' && location.pathname !== '/login' && location.pathname !== '/signup' && 
            <Sidebar open={sidebarOpen} onClose={toggleSidebar} />
          }
          <Suspense fallback={<Pageloader />}>
            <Routes>
              {user &&
                <Route path='*' element={<NotFound />} />
              }
              {user?.user_type !== "Merchant" ?
                <>
                  {(user) && (user?.id === 1 || userPermission?.Merchants?.add || userPermission?.Merchants?.list) &&
                    <Route exact path="/merchant" element={<Merchant />} />
                  }
                  {(user) && (user?.id === 1 || userPermission?.Merchants?.add || userPermission?.Merchants?.list) &&
                    <Route exact path="/signup-merchant" element={<SignupMerchant />} />
                  }
                  {(user) && (user?.id === 1 || userPermission?.Branches?.add || userPermission?.Branches?.list) &&
                    <Route exact path="/branches" element={<BranchView />} />
                  }
                  {(user) && (user?.id === 1) &&
                    <Route exact path="/users" element={<UsersView />} />
                  }
                  {(user) && (user?.id === 1 || userPermission?.Tracking_Scans?.add || userPermission?.Tracking_Scans?.list) &&
                    <Route exact path="/scanStatus" element={<ScanView />} />
                  }
                  <Route path="/merchant-details" element={<SiteSetting />} />
                  <Route path="/merchants/pricing" element={<PricingView />} />
                  <Route path="/assets" element={<Asset />} />
                  <Route path="/couriers" element={<Couriers />} />
                  <Route path="/ivr-recording" element={<Ivr />} />
                </>
                :
                <>
                  <Route path="/siteSetting" element={<SiteSetting />} />
                  <Route path="/channel" element={<Channel />} />
                </>
              }
              {(user) && (user?.id === 1 || userPermission?.NDR?.add || userPermission?.NDR?.list || userPermission?.NDR?.import || userPermission?.NDR?.export || user?.user_type === "Merchant") &&
                <Route path="/ndr" element={<NdrTab />} />
              }
              {(user) && (user?.id === 1 || userPermission?.Remittance?.add || userPermission?.Remittance?.list || userPermission?.Remittance?.import || userPermission?.NDR?.export || user?.user_type === "Merchant") &&
                <Route path="/remittance" element={<Remittance />} />
              }
              <Route exact path="/admin" element={<AdminSignIn />} />
              <Route path="/login" element={<MerchantSignIn />} />
              <Route path="/signup" element={<MerchantSignUp />} />
              {(user) && (user?.id === 1 || userPermission?.Dashboard?.view || user?.user_type === "Merchant") &&
                <Route exact path="/" element={<DashboardTab />} />
              }
              {(user) && (user?.id === 1 || userPermission?.Orders?.add || userPermission?.Orders?.list || userPermission?.Orders?.upload || userPermission?.Orders?.upload_status || user?.user_type === "Merchant") &&
                <Route exact path="/orders" element={<ShipmentsView />} />
              }
              {(user) && (user?.id === 1 || userPermission?.Orders?.add || userPermission?.Orders?.list || userPermission?.Orders?.upload || userPermission?.Orders?.upload_status || user?.user_type === "Merchant") &&
                <Route exact path="/orders-b2b" element={<ShipmentsViewb2b />} />
              }
              {(user) && (user?.id === 1 || userPermission?.Orders?.add || user?.user_type === "Merchant") &&
                <Route path="/create-order" element={<CreateOrder />} />
              }
              {(user) && (user?.id === 1 || userPermission?.Orders?.add || user?.user_type === "Merchant") &&
                <Route path="/create-order-b2b" element={<CreateOrderb2b />} />
              }
              {(user) && (user?.id === 1 || userPermission?.Orders?.list || user?.user_type === "Merchant") &&
                <Route path="/orders-details" element={<OrderDetails />} />
              }
              {(user) && (user?.id === 1 || userPermission?.Orders?.list || user?.user_type === "Merchant") &&
                <Route path="/orders-details-b2b" element={<OrderDetailsb2b />} />
              }
              {(user) && (user?.id === 1 || userPermission?.Merchant_Warehouse?.add || userPermission?.Merchant_Warehouse?.list || user?.user_type === "Merchant") &&
                <Route exact path="/warehouse" element={<PickupPointsView />} />
              }
              {(user) && (user?.id === 1 || userPermission?.Pickup_Requests?.add || userPermission?.Pickup_Requests?.list || user?.user_type === "Merchant") &&
                <Route exact path="/pickupRequest" element={<PickupView />} />
              }
              {(user) && (user?.id === 1 || userPermission?.RTO_Requests?.add || userPermission?.RTO_Requests?.list || user?.user_type === "Merchant") &&
                <Route exact path="/rtoRequest" element={<RTOView />} />
              }
              {(user) && (user?.id === 1 || userPermission?.Downloads?.list || user?.user_type === "Merchant") &&
                <Route exact path="/download" element={<DownloadView />} />
              }
              {(user) && (user?.id === 1 || userPermission?.Tracking_Codes?.add || userPermission?.Tracking_Codes?.list) &&
                <Route exact path="/tracking" element={<TrackingView />} />
              }
              {(user) && (user?.id === 1 || userPermission?.Serviceability?.import || userPermission?.Serviceability?.list || user?.user_type === "Merchant") &&
                <Route exact path="/serviceability" element={<ServiceabilityView />} />
              }
              {(user) && (user?.id === 1 || userPermission?.Weight?.import || userPermission?.Weight?.list || user?.user_type === "Merchant") &&
                <Route exact path="/weight" element={<WeightTab />} />
              }
              {(user) && (user?.id === 1 || userPermission?.Freight?.import || userPermission?.Freight?.list || user?.user_type === "Merchant") &&
                <Route exact path="/freight" element={<FreightTab />} />
              }
              {(user) && (user?.id === 1 || userPermission?.Invoice?.add || userPermission?.Invoice?.import || userPermission?.Invoice?.list || user?.user_type === "Merchant") &&
                <Route exact path="/invoice" element={<InvoiceTab />} />
              }
              {(user) && (user?.id === 1 || userPermission?.['Credit note']?.add || userPermission?.['Credit note']?.import || userPermission?.['Credit note']?.list || user?.user_type === "Merchant") &&
                <Route exact path="/credit-note" element={<CreditNoteTab />} />
              }
              <Route path="/utility" element={<Utility />} />
              <Route path="/recharge" element={<Recharge />} />
              <Route path="/price-calulator" element={<CalculatorTab />} />
              <Route path="/payment/:slug" element={<PaymentStatus />} />
            </Routes>
          </Suspense>
          {!['/login', '/admin', '/signup'].includes(location.pathname) && user?.user_type === "Merchant" && (
            <>
              <Footer />
            </>
          )}
        </div>
      </ThemeProvider>
    </CommonContextProvider>
  );
}

export default App;
